import {ValueListener} from "./interfaces";
import EventPerson from "../eventsManager/EventPerson";
import {observeRSVPQuestionsV2} from "./observeRSVPQuestionsV2";

export const observeIncompleteResponses = (eventDataSource: any, listener: ValueListener<boolean>) => {
    listener = eventDataSource.wrapListener(listener);
    let pageConfig, rsvpQuestions;
    let person;

    const compute = function () {
        if (!pageConfig.rsvp) return false;
        if (!person) return true;
        let incompleteResponse = false;

        let guestAttending = person.getDetail("rsvp") !== false;
        let attendanceQuestion = rsvpQuestions.find(q => q.id === "rsvp");

        let rsvpDependentIds = (attendanceQuestion && !guestAttending) ? attendanceQuestion.questions.dependentOnQuestion(attendanceQuestion).map(q => q.id) : [];
        let requiredSteps = rsvpQuestions.filter(q => rsvpDependentIds.indexOf(q._questionId) < 0);
        requiredSteps.forEach(function(q){
            var val = person.getAnswer(q);
            var timeVal = person.getAnswerTimestamp(q);
            if ((val === null || val === undefined) && (timeVal === null || timeVal === undefined)) {
                incompleteResponse = true;
                return false;
            }
        });

        return incompleteResponse;
    };

    const onUpdate = function () {
        var anyUndef = ([pageConfig, rsvpQuestions, person].filter(x => (typeof x == "undefined")).length > 0);
        if (anyUndef) {
            return;
        }
        listener.onValue(compute());
    };

    eventDataSource.observePageConfig({onValue: function (dashboardConfig) {
        pageConfig = dashboardConfig;
        onUpdate();
    }});

    observeRSVPQuestionsV2(eventDataSource, {onValue: function (q) {
        rsvpQuestions = q.asSortedArray().filter(q => q.isEnabled);
        onUpdate();
    }});

    new EventPerson(eventDataSource, {onValue: function (p) {
        person = p;
        onUpdate();
    }});
};